import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Button, Input, Select, DatePicker, message, AutoComplete, Spin, Modal, Row, Col } from 'antd';
import md5 from 'md5';
import { LimitTextArea } from 'antd-input'
import history from '@/containers/history';
import { getPiList, getPiListlab, signUser, userApplyInfo, getLabUserList, getSignUserList, addUserAccount, getLabList_box, getOrgList_box, getlabRoleList_platform_box } from '@/api/api';
import moment from 'moment';
import styles from './sign.module.css';

const { Option } = Select;
const FormItem = Form.Item;

const formItemLayout1 = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
}
const formItemLayout2 = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 }
}
const formItemLayout3 = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
}
const formItemLayout10 = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}
const formItemLayout4 = {
    labelCol: { span: 3 },
    wrapperCol: { span: 20 }
}
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 15,
            offset: 9,
        },
    },
};
class SignUser extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            id: props.infoData ? props.infoData.id : '',
            loading: false,
            submitLoading: false,
            piList: (props.infoData && props.infoData.piList) ? props.infoData.piList : [],
            inYear: false,
            autoCpResult: [], //邮箱自动补全后缀
            infoData: props.infoData ? props.infoData : {}, //修改注册信息时的初始化信息
            leaderList: [],
            orgBoxList: [],
            labBoxList: [],
            roleBoxList: [],
            signType: this.props.signType
        };
        this.signSubmit = this.signSubmit.bind(this);
        this.setValue = this.setValue.bind(this);
        this.autoCpSearch = this.autoCpSearch.bind(this);
    }

    componentDidMount() {
        const that = this;

        if (that.state.signType !== 3) {
            this.getSelectData();
            this.getLabUserList();
        }
    }

    // 获取下拉列表信息
    getSelectData() {
        console.log(this.state.infoData.id);
        const that = this;
        //获取机构下拉列表
        // getOrgList_box({},res=>{ 
        //     if(res.statusCode === 1000){
        //         that.setValue('orgBoxList',res.orgBoxList)
        //     }
        // },err=>{
        //     console.log(err)
        // });
        // 获取PI课题组列表
        console.log(that.state.signType);
        console.log(that.state.signType !== 2);
        if (that.state.signType !== 2 && that.state.signType !== 3) {
            getPiList({}, res => {
                console.log(res)
                if (res.statusCode === 1000) {
                    that.setValue('piList', res.list)
                }
            }, err => {
                console.log(err)
            });
        }
        else {
            getPiListlab({}, res => {
                console.log(res)
                if (res.statusCode === 1000) {
                    that.setValue('piList', res.list)
                }
            }, err => {
                console.log(err)
            });
        }



        // 实验室下拉列表
        // getLabList_box({orgId:orgId},res=>{
        //     console.log(res)  
        //     if(res.statusCode === 1000){
        //         that.setValue('labBoxList',res.labBoxList)
        //     }  
        // },err=>{
        //     console.log(err)
        // })
        //获取实验室平台角色列表
        getlabRoleList_platform_box({}, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('roleBoxList', res.roleBoxList)
            }
        }, err => {
            console.log(err)
        })
    }

    // 获取实验室人员列表，导师下拉用
    getLabUserList(rows) {
        const that = this;
        let params = {
            page: 1,
            rows: rows ? rows : 1000,
            ifAll: 1,
        };
        if (that.state.signType == 2) {
            getLabUserList(params, res => {
                console.log(res);
                if (res.statusCode !== 1000) {
                    return
                }
                if (res.total > params.rows) {
                    that.getLabUserList(res.total);
                    return
                };
                that.setValue('leaderList', res.rows)
            }, err => {
                console.log(err)
            })
        }
        else {
            getSignUserList(params, res => {
                console.log(res);
                if (res.statusCode !== 1000) {
                    return
                }
                if (res.total > params.rows) {
                    that.getLabUserList(res.total);
                    return
                };
                that.setValue('leaderList', res.rows)
            }, err => {
                console.log(err)
            })
        }

    }

    //邮箱后缀自动输入提示
    autoCpSearch = (value) => {
        let autoCpResult;
        if (!value || value.indexOf('@') >= 0) {
            autoCpResult = [];
        } else {
            autoCpResult = ['gmail.com', '163.com', 'qq.com', 'yahoo.com', 'hotmail.com', 'sina.com', 'sohu.com'].map(domain => `${value}@${domain}`);
        }
        this.setState({ autoCpResult });
    }

    // 提交验证
    signSubmit = (e) => {
        const that = this;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                console.log(err)
                message.warning('请输入必填项！')
                return
            };
            that.setState({
                sureLoading: true
            });
            // 检验2次密码输入是否一样
            if (that.state.signType !== 2 && that.state.signType !== 3 && values.loginPws !== values.loginPws2) {
                message.warning('两次输入的密码不一致，请重新输入');
                that.props.form.setFieldsValue({ ['loginPws2']: '' });
                return
            };
            let params = {
                source: 1
            };
            if (that.state.signType !== 2 && that.state.signType !== 3) {
                //删除2次密码输入字段
                delete values.loginPws2;
                params.type = parseInt(that.props.signType); //定义请求参数
            };
            for (let i in values) {
                if (typeof values[i] !== 'undefined') {
                    params[i] = values[i];
                    //格式化年份，并将其转为数值
                    if (i === 'inYear') {
                        params[i] = parseInt(values['inYear'].format('YYYY'))
                    };
                    //md5登陆密码
                    if (i === 'loginPws') {
                        params[i] = md5(values.loginPws)
                    }
                };
            };
            console.log(params);
            this.userSubmit(params)

        });
    }

    // 注册请求
    userSubmit(params) {
        const that = this;
        const { signType } = this.state;
        that.setState({
            sureLoading: true
        });
        console.log(signType);
        if (!(signType === 2)) {
            this.loginSignUser(params)
        } else {
            this.labSignUser(params)
        }
    }

    // 登陆注册
    loginSignUser(params = {}) {
        const that = this;
        signUser(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setState({
                    sureLoading: false
                });
                that.props.setValue('signScs', res);
                that.props.setValue('modalVisible', false)
            } else {
                message.warning(res.message)
            }
        }, err => {
            that.setState({
                sureLoading: false
            });
            console.log(err)
            // message.error('提交失败')
            Modal.error({
                content: '提交失败',
            });
        })
    }

    // 实验室人员开通
    labSignUser(params) {
        const that = this;
        console.log(this.state.infoData.id);
        params = {
            ...params,
            pwd: this.state.infoData.loginPws ? this.state.infoData.loginPws : '',
            id: this.state.infoData.id ? this.state.infoData.id : '',
            userLinkId: this.state.infoData.userLinkId ? this.state.infoData.userLinkId : '',
        }
        addUserAccount(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setState({
                    sureLoading: false
                });
                message.success('提交成功');
                that.props.modalToggle(false)
                that.props.getDataList()
                // history.goBack()
            } else {
                message.warning(res.message)
            }
        }, err => {
            that.setState({
                sureLoading: false
            });
            console.log(err)
            // message.error('提交失败')
            Modal.error({
                content: '提交失败',
            });
        })
    }

    setValue = (feild, value) => {
        this.setState({
            [feild]: value
        })
    }
    myselect = (value) => {

        if (value) {
            console.log(value)
            this.setState({
                myFlag: true
            })
        } else {
            this.setState({
                myFlag: false
            })
        }
    }
    render() {
        const that = this;
        const { signType } = this.state;//2为全部类型，从实验室成员新增入口，0为内部人员注册，1为外部人员注册
        const { submitLoading, piList, piListlab, inYearOpen, autoCpResult, infoData, leaderList, orgBoxList, labBoxList, roleBoxList, id } = this.state;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        return (

            <Form onSubmit={this.signSubmit} className={`${styles.sign_form} mycao`} {...formItemLayout} style={{ maxHeight: signType === 2 ? 'auto' : 'auto' }}>

                {signType === 2 &&
                    <div>
                        <Row>
                            <Col span={24}>
                                <Col span={12}>
                                    <FormItem label="账号" className={styles.form_item}>
                                        {getFieldDecorator('username', {
                                            rules: [
                                                { required: true, message: '请输入账号名' }, { min: 4, message: '输入账号名不少于四位' },
                                            ],
                                            initialValue: infoData.username ? infoData.username : '',
                                            validateTrigger: 'onBlur',
                                        })(
                                            <Input
                                                placeholder="请输入账号名"
                                                size='default'
                                                autoComplete="off" disableautocomplete='true'
                                                style={{ maxWidth: '240px' }}
                                                disabled={id && true}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="密码设置" className={styles.form_item}>
                                        {id ? getFieldDecorator('loginPws', {
                                            rules: [
                                                { min: 5, max: 16, message: '5-16字符' },
                                            ],
                                            // rules: [
                                            //     { pattern: /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/, message: '5-16字符，仅限于字母数字下划线' }
                                            // ],
                                            validateTrigger: 'onBlur',
                                        })(
                                            <Input
                                                // placeholder="不填写则不修改密码"
                                                size='default'
                                                // visibilityToggle={false}
                                                type='password'
                                                autoComplete="off" disableautocomplete='true'
                                                style={{ maxWidth: '250px' }}
                                            />
                                        )
                                            :
                                            getFieldDecorator('loginPws', {
                                                rules: [
                                                    { min: 5, max: 16, message: '5-16字符' },
                                                ],
                                                validateTrigger: 'onBlur',
                                            })(
                                                <Input
                                                    placeholder="不填写则默认密码为：123456"
                                                    size='default'
                                                    autoComplete="off" disableautocomplete='true'
                                                    style={{ maxWidth: '250px' }}
                                                />
                                            )
                                        }
                                    </FormItem>
                                </Col>
                            </Col>
                            {signType !== 2 && signType !== 3 &&
                                <Col span={12}>
                                    <FormItem label="确认密码" className={styles.form_item}>
                                        {getFieldDecorator('loginPws2', {
                                            rules: [
                                                { min: 5, max: 16, message: "5-16个字符" },
                                                //     { pattern: /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/, message: '5-16字符，仅限于字母数字下划线!' }
                                            ],
                                            validateTrigger: 'onBlur',
                                        })(
                                            <Input
                                                placeholder="请再次输入密码"
                                                size='default'
                                                autoComplete="off" disableautocomplete='true'
                                                style={{ maxWidth: '160px' }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            }

                            <Col span={12}>
                                <FormItem {...formItemLayout} label="人员类型">
                                    {id ? getFieldDecorator('type', {
                                        rules: [{ required: true, message: '请选择' }],
                                        initialValue: infoData.type ? infoData.type : 0,
                                        validateTrigger: "onBlur"
                                    })(
                                        <Select dropdownClassName="form_select" style={{ width: "160px" }} disabled onChange={this.myselect}>
                                            <Option value={0} key={0}>内部人员</Option>
                                            <Option value={1} key={1}>外部人员</Option>
                                        </Select>
                                    )
                                        :
                                        getFieldDecorator('type', {
                                            rules: [{ required: true, message: '请选择' }],
                                            initialValue: infoData.type ? infoData.type : 0,
                                            validateTrigger: "onBlur"
                                        })(
                                            <Select dropdownClassName="form_select" style={{ width: "160px" }} onChange={this.myselect}>
                                                <Option value={0} key={0}>内部人员</Option>
                                                <Option value={1} key={1}>外部人员</Option>
                                            </Select>
                                        )
                                    }
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="角色">
                                    {getFieldDecorator('roleId', {
                                        rules: [{ required: true, message: '请选择' }],
                                        initialValue: infoData.roleId ? infoData.roleId : 148,
                                        validateTrigger: "onBlur"
                                    })(
                                        <Select dropdownClassName="form_select" style={{ width: "160px" }} disabled={this.state.myFlag}>
                                            {roleBoxList.map(x => {
                                                return (
                                                    <Option value={x.id} key={x.id}>{x.roleName}</Option>
                                                )
                                            })}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </div>

                }

                {signType === 3 &&
                    <Row>
                        <Col span={24}>
                            <FormItem label="邀请码" {...formItemLayout2} className={styles.form_item}>
                                {getFieldDecorator('signCode', {
                                    rules: [
                                        { required: true, message: '请输入邀请码' },
                                    ],
                                    initialValue: infoData.signCode ? infoData.signCode : '',
                                    validateTrigger: 'onBlur',
                                })(
                                    <Input
                                        placeholder="请输入实验室注册邀请码"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '240px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                }
                <div style={{ marginLeft: this.props.signType === 2 && '-36px' }}>
                    <Row>
                        <Col span={12}>
                            <FormItem label="姓名" {...formItemLayout3} className={styles.form_item}>
                                {getFieldDecorator('name', {
                                    rules: [
                                        { required: true, message: '请输入姓名' }, { max: 10, message: "最大输入10个字" }
                                    ],
                                    initialValue: infoData.nickName ? infoData.nickName : '',
                                    validateTrigger: 'onBlur',
                                })(
                                    <Input
                                        placeholder="请输入姓名"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '145px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={12} className={styles.changeUi}>
                            <FormItem label="手机号码" {...formItemLayout10} className={styles.form_item}>
                                {getFieldDecorator('phone', {
                                    rules: [
                                        { required: true, message: '请输入手机号码' },
                                        { max: 11, pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码!' }
                                        // { pattern: '^[a-zA-Z0-9]*$', message: '只支持数字、英文，不区分大小写，请正确输入' }
                                    ],
                                    validateTrigger: 'onBlur',
                                    initialValue: infoData.mobile ? infoData.mobile : ''
                                })(
                                    <Input
                                        placeholder="请输入手机号码"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '240px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="身份证号码"  {...formItemLayout2} className={styles.form_item}>
                                {getFieldDecorator('idCord', {
                                    rules: [
                                        // { required: true, message: '请输入身份证号码' },
                                        { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号码!' }
                                    ],
                                    validateTrigger: 'onBlur',
                                    initialValue: infoData.idCord ? infoData.idCord : '',
                                })(
                                    <Input
                                        placeholder="请输入身份证号码"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '320px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                </div>
                {/* 外部注册 */}
                {(signType === 1 || getFieldValue('type') === 1) &&
                    <Row>
                        <Col span={12}>
                            <FormItem label="单位" className={styles.form_item}>
                                {getFieldDecorator('workplace', {
                                    initialValue: infoData.workplace ? infoData.workplace : '',
                                })(
                                    <Input
                                        placeholder="请输入单位"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '240px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label="课题组" className={styles.form_item}>
                                {getFieldDecorator('piName', {
                                    initialValue: infoData.piName ? infoData.piName : '',
                                })(
                                    <Input
                                        placeholder="请输入课题组名称"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '220px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                }
                {/* 内部注册 */}
                {(signType === 0 || getFieldValue('type') === 0) &&
                    <div>
                        <Row>
                            <Col span={12}>
                                <FormItem label="所属课题组" className={styles.form_item}>
                                    {getFieldDecorator('piId', {
                                        initialValue: infoData.piId ? infoData.piId : '',
                                    })(
                                        <Select showSearch
                                            style={{ maxWidth: '320px' }}
                                            placeholder="请选择课题组"
                                            optionFilterProp="children"
                                            notFoundContent="无法找到"
                                            searchPlaceholder="输入关键词">
                                            {piList && piList.map(x => {
                                                return <Option value={x.id} key={x.id}>{x.name}</Option>
                                            })}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem label="身份类型" className={styles.form_item}>
                                    {getFieldDecorator('userType', {
                                        initialValue: infoData.userType ? infoData.userType : 1,
                                    })(
                                        <Select dropdownClassName="form_select" style={{ maxWidth: '160px' }}>
                                            <Option value={1} key={1}>学生</Option>
                                            <Option value={2} key={2}>合同制</Option>
                                            <Option value={3} key={3}>在编人员</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            {getFieldValue('userType') === 1 &&
                                <Col span={12}>
                                    <FormItem label="导师" >
                                        {getFieldDecorator('leader', {
                                            initialValue: infoData.leader ? infoData.leader : ''
                                        })(
                                            <Select showSearch
                                                style={{ maxWidth: '160px' }}
                                                placeholder="请选择人员"
                                                optionFilterProp="children"
                                                notFoundContent="无法找到"
                                                searchPlaceholder="输入关键词">

                                                {leaderList.map(x => {
                                                    return <Option value={x.id} key={x.id}>{x.nickName}</Option>
                                                })}
                                            </Select>
                                        )}
                                    </FormItem>
                                </Col>
                            }
                            {getFieldValue('userType') === 1 &&
                                <Col span={12}>
                                    <FormItem label="入学年份" className={styles.form_item}>
                                        {getFieldDecorator('inYear', {
                                            initialValue: infoData.inYear ? moment(infoData.inYear.toString(), 'YYYY') : moment('2019', 'YYYY')
                                        })(
                                            <DatePicker
                                                mode='year'
                                                format='YYYY'
                                                open={inYearOpen}
                                                onOpenChange={open => {
                                                    that.setValue('inYearOpen', open)
                                                }}
                                                onPanelChange={(value, mode) => {
                                                    that.props.form.setFieldsValue({ ['inYear']: value });
                                                    that.setValue('inYearOpen', false)
                                                }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>

                            }
                        </Row>
                    </div>
                }
                <Row>

                    {signType !== 3 &&
                        <Col span={12}>
                            <FormItem label="研究方向" className={styles.form_item}>
                                {getFieldDecorator('researchArea', {
                                    initialValue: infoData.researchArea ? infoData.researchArea : '',
                                })(
                                    <Input
                                        placeholder="请输入研究方向"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '160px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    }
                    {signType !== 3 &&
                        <Col span={12}>
                            <FormItem label="邮箱" className={styles.form_item}>
                                {getFieldDecorator('mailbox', {
                                    rules: [
                                        { pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g, message: '请输入正确的邮箱地址!' }
                                    ],
                                    initialValue: infoData.mailbox ? infoData.mailbox : ''
                                })(
                                    <AutoComplete
                                        // style={{ width: 200 }}
                                        onSearch={this.autoCpSearch}
                                        placeholder="请输入邮箱地址"
                                        style={{ maxWidth: '240px' }}
                                    >
                                        {autoCpResult.map(email => {
                                            return <AutoComplete.Option key={email}>{email}</AutoComplete.Option>
                                        })}
                                    </AutoComplete>
                                )}
                            </FormItem>
                        </Col>
                    }

                    {signType === 3 &&
                        <Col span={24}>
                            <FormItem label="登录名" {...formItemLayout2} className={styles.form_item}>
                                {getFieldDecorator('userName', {
                                    rules: [
                                        { required: true, message: '请输入登录名' }, { min: 4, message: "输入登录名不少于四位" }
                                    ],
                                    initialValue: infoData.userName ? infoData.userName : '',
                                    validateTrigger: 'onBlur',
                                })(
                                    <Input
                                        placeholder="请输入登录名"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '240px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>}
                    {signType === 3 &&
                        <Col span={24}>
                            <FormItem label="密码" {...formItemLayout2} className={styles.form_item}>
                                {getFieldDecorator('loginPws', {
                                    rules: [
                                        { required: true, message: '请输入密码' },
                                        { min: 5, max: 16, message: "5-16个字符" },
                                        // { pattern: /^[a-zA-Z0-9]{6,15}$/, message: '6-16字符，仅限于字母数字下划线' }
                                    ],
                                    initialValue: infoData.loginPws ? infoData.loginPws : '',
                                    validateTrigger: 'onBlur',
                                })(
                                    <Input
                                        placeholder="请输入密码"
                                        size='default'
                                        autoComplete="off" disableautocomplete='true'
                                        style={{ maxWidth: '240px' }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    }
                    {signType === 3 &&
                        <Col span={24}>
                            <FormItem label="备注" {...formItemLayout2} className={styles.form_item}>
                                {getFieldDecorator('registerRemark', {
                                    initialValue: infoData.registerRemark ? infoData.registerRemark : '',
                                    validateTrigger: 'onBlur',
                                })(
                                    <LimitTextArea
                                        rows={4}
                                        maxLength={50}
                                        placeholder={'请输入内容...'}
                                    />
                                )}
                            </FormItem>

                        </Col>
                    }
                    {/* 新增页面的内部人员注册 */}
                    {this.props.modalToggle ? <p className='tc'>
                        <Button className="mr20" onClick={() => {
                            this.props.modalToggle(false)
                        }}>返回</Button>
                        <Button htmlType="submit" type="primary" loading={submitLoading} >提交</Button>
                    </p> :
                        <p className='tc'>
                            <Button size="default" className="mr20" onClick={() => {
                                if (signType === 2) {
                                    history.goBack()
                                } else {
                                    that.props.setValue('modalVisible', false)
                                }
                            }}>{signType === 2 ? '返回' : '取消'}</Button>
                            <Button htmlType="submit" type="primary" size="default" loading={submitLoading} >提交</Button>
                        </p>}
                    {/* <Col span={24} style={{ marginTop: "20px" }}>
                        {this.props.modalToggle ?
                            <FormItem className={styles.login_btns}  {...tailFormItemLayout}>
                                <Button className="mr20" onClick={() => {
                                    this.props.modalToggle(false)
                                }}>返回</Button>
                                <Button htmlType="submit" type="primary" loading={submitLoading} >提交</Button>
                            </FormItem> :
                            <FormItem className={styles.login_btns}  {...tailFormItemLayout}>
                                <Button size="default" className="mr20" onClick={() => {
                                    if (signType === 2) {
                                        history.goBack()
                                    } else {
                                        that.props.setValue('modalVisible', false)
                                    }
                                }}>{signType === 2 ? '返回' : '取消'}</Button>
                                <Button htmlType="submit" type="primary" size="default" loading={submitLoading} >提交</Button>
                            </FormItem>}
                    </Col> */}
                </Row>
            </Form >

        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps)(Form.create({})(SignUser));

